import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import config from "../../Config";
import StudentPanelMenu from "./StudentPanelMenu";
import { getStudentSupportApiPayload } from "./studentSupportApiPayload";

function StudentSupportTickets() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Support/GetSupportTicketStudent",
      headers: { "Content-Type": "application/json" },
      data: getStudentSupportApiPayload({ pageNo: 1, pageSize: 50 }),
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          setTickets(res.data.ListofTickets || []);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <>
      <StudentPanelMenu />
      <div className="page-head">
        <div className="container">
          <div className="page-title">My support tickets</div>
        </div>
      </div>
      <div className="container pb-4">
        <div className="mb-3 text-end">
          <Link to="/student-panel/support/raise" className="button button-primary">
            Raise new ticket
          </Link>
        </div>
        <div className="card">
          <div className="card-body">
            {loading ? (
              <p className="text-muted">Loading...</p>
            ) : tickets.length === 0 ? (
              <p className="text-muted mb-0">No tickets yet.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Ticket</th>
                      <th>Date</th>
                      <th>Department</th>
                      <th>Subject</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {tickets.map((item) => (
                      <tr key={item.ID}>
                        <td>{item.TicketID}</td>
                        <td>{moment(item.Dated).format("DD MMM, YYYY")}</td>
                        <td>{item.TicketType}</td>
                        <td>{item.Subject}</td>
                        <td>{item.Status}</td>
                        <td>
                          <NavLink
                            to={`/student-panel/support/tickets/${item.ID}`}
                            className="button-detail"
                          >
                            <span>View</span>{" "}
                            <i className="ri-arrow-right-s-line"></i>
                          </NavLink>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentSupportTickets;

